<template>
  <button class="button primary" @click="login">
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "PrimaryButton",
  props: {
    text: String,
    privilige: String,
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
  },
};
</script>

<style lang="scss" scoped>
.primary {
  background-color: var(--primary-color);
  border: none;
  margin: 0 0px;
  padding: 0.59em 1.5em;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  color: white;
  font-size: 24px;

  &:hover {
    background-color: var(--primary-color);
  }
}

@media only screen and (max-width: 768px) {
  .primary {
    font-size: 16px;
  }
}
</style>